// Burst badge shown on a list row when the row is part of a sustained
// attack burst (`correlation.related_event_count > 1`). Renders
// nothing when count is 1 or correlation is null — the honest "no
// burst" signal.
//
// Click handler is a noop in Tier 2 (Tier 3 adds the burst-list
// modal). For Tier 2 we still render the badge with the count so
// operators see the value immediately.

import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { Activity } from "lucide-react";
import { formatBurstBadge, formatBurstTooltip } from "../../../../../utils/wafEventV3";
import colors from "../../../../../utils/colors";

export default function BurstBadge({ correlation, onClick }) {
  const label = formatBurstBadge(correlation);
  if (!label) return null;
  const tooltip = formatBurstTooltip(correlation) || `${correlation.related_event_count} related events`;
  return (
    <Tooltip title={tooltip}>
      <Box
        component="button"
        onClick={(e) => { e.stopPropagation(); if (onClick) onClick(correlation); }}
        sx={{
          all: "unset",
          display: "inline-flex", alignItems: "center", gap: 0.5,
          px: 0.75, height: 20, borderRadius: "10px",
          backgroundColor: "#FFEDD5",
          color: "#9A3412",
          border: "1px solid #FFD3A8",
          fontSize: 11, fontWeight: 600, lineHeight: 1,
          cursor: onClick ? "pointer" : "default",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        <Activity size={11} color="#9A3412" />
        {label}
      </Box>
    </Tooltip>
  );
}
